/**
 * @Author: Junaid Atari junaid.attari@invozone.dev
 * @Date: 2025-02-12 15:08:10
 */

import ObjectPath from 'object-path';

/**
 * Parse the axios error response and return the error message
 * @param error - The axios error response
 */
export const parseAxiosError = (error: unknown) => {
  const accessor = ObjectPath(error as Record<string, unknown>);

  if (accessor.has('response.data.message'))
    return accessor.get('response.data.message');

  if (accessor.has('data.message'))
    return accessor.get('data.message');

  if (accessor.has('message'))
    return accessor.get('message');

  return 'Unknown error occurred';
};
